const http = require('../lib/httpClient');
const { getCookie, getChannelId, getEcommId, getXCommerceValue } = require('../lib/browserData');
const { COOKIES, COMMERCE_HEADER } = require('../constants');

const resetPasswordError = {
  code: 'RESET_PASSWORD_ERROR',
  message: 'Unable to reset password',
};

const endpoint = '/s/auth/v1/password/reset';

async function catalystResetPasswordWithCurrent(
  currentPassword,
  newPassword,
  tenantId,
  catalystBaseUrl = '',
) {
  const sessionId = getCookie(COOKIES.SESSION.VALUE);
  if (!sessionId) {
    return {
      data: undefined,
      errors: [{ code: 'RESET_PASSWORD_ERROR', message: 'Session not found' }],
    };
  }
  const result = await http.post(
    `${catalystBaseUrl}${endpoint}`,
    { currentPassword, newPassword },
    {
      headers: {
        'x-channel-id': getChannelId(),
        'x-ecomm-name': getEcommId(tenantId),
        authorization: sessionId,
        'x-commerce': getXCommerceValue(catalystBaseUrl) || COMMERCE_HEADER,
      },
    },
  );

  const { responseBody } = result || {};

  if (!responseBody) return { data: undefined, errors: [resetPasswordError] };
  const { success, errors } = responseBody;
  if (errors) return { data: undefined, errors };
  if (!success) {
    return {
      data: undefined,
      errors: [{ code: 'RESET_PASSWORD_ERROR', message: 'Unable to reset password' }],
    };
  }
  return { data: { success }, errors: [] };
}

module.exports = catalystResetPasswordWithCurrent;
